import React from "react";
import { ShieldCheck } from "lucide-react";

export default function WhyStorage() {
  return (
    <section
      id="why"
      data-testid="section-why"
      className="bg-ice py-20 lg:py-28"
    >
      <div className="container-pc">
        <div className="max-w-2xl">
          <p className="eyebrow">Considered storage</p>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-navy tracking-tighter">
            Why proper storage matters.
          </h2>
        </div>

        <div className="mt-10 grid lg:grid-cols-2 gap-8 lg:gap-12 text-ink">
          <p className="text-base lg:text-[17px] leading-[1.75] text-ink/80">
            Many research materials, including peptides, are temperature-sensitive. Suppliers
            and manufacturers provide specific storage instructions to maintain product
            integrity over time. A clean, organised, temperature-controlled environment is
            part of responsible handling — whether you&rsquo;re working in a home lab, a
            clinic, or a professional research facility.
          </p>
          <p className="text-base lg:text-[17px] leading-[1.75] text-ink/80">
            PeptiChill was designed to provide that environment in a compact, considered
            form: a dedicated space for storing research-use peptides and other
            temperature-sensitive laboratory materials, away from food, beverages, and
            household items.
          </p>
        </div>

        <div className="mt-10">
          <span
            className="inline-flex items-center gap-2 rounded-full bg-white border border-silver/60 px-4 py-2 text-xs text-ink/80"
            data-testid="why-compliance-pill"
          >
            <ShieldCheck size={14} className="text-cyan" strokeWidth={2} />
            A storage solution only. Always follow the storage instructions supplied with your
            materials or products.
          </span>
        </div>
      </div>
    </section>
  );
}
